import React from 'react';

import { createBrowserRouter, Navigate, Outlet } from 'react-router-dom';

import { Brands, BrandDetail, Connections } from '../features/brands';
import { DataShareUpdateLoadingProvider } from '../features/brands/connections/context/data-share-update-loading-context';
import { Catalog } from '../features/catalog';

export const ROUTES = {
  BRANDS: '/brands',
  CATALOG: '/brand-catalog',
  CONNECTIONS: '/connections',
};

export const router = createBrowserRouter([
  {
    element: <Outlet />,
    children: [
      {
        path: ROUTES.BRANDS,
        element: <Brands />,
      },
      {
        path: `${ROUTES.BRANDS}/:brandId`,
        element: <BrandDetail />,
      },
      {
        path: ROUTES.CONNECTIONS,
        element: (
          <DataShareUpdateLoadingProvider>
            <Connections />
          </DataShareUpdateLoadingProvider>
        ),
      },
    ],
  },
  {
    path: ROUTES.CATALOG,
    element: <Catalog />,
  },
  {
    path: '*',
    element: <Navigate to={ROUTES.BRANDS} replace />,
  },
]);
